<div
  [ngClass]="{
    'bg-gray-50 ring-gray-50': mode() === 'info',
    'bg-orange-50 ring-orange-50': mode() === 'warning',
    'bg-red-50 ring-red-50': mode() === 'error',
    'bg-green-50 ring-green-50': mode() === 'success'
  }"
  class="rounded-md p-4 shadow-lg">
  <div class="flex" :title="tooltip">
    <div class="ml-3 flex grow flex-col gap-2">
      @if (message()) {
        <h3
          class="message text-sm font-medium"
          [ngClass]="{
            'text-gray-800': mode() === 'info',
            'text-orange-800': mode() === 'warning',
            'text-red-800': mode() === 'error',
            'text-green-800': mode() === 'success'
          }">
          {{ message() }}
        </h3>
      }
      @if (description()) {
        <div
          class="description text-sm"
          [ngClass]="{
            'text-gray-600': mode() === 'info',
            'text-orange-700': mode() === 'warning',
            'text-red-700': mode() === 'error',
            'text-green-700': mode() === 'success'
          }">
          <p>
            {{ description() }}
          </p>
        </div>
      }
      @if (actionLabel()) {
        <button
          (click)="actionClick.emit()"
          class="mt-2 text-sm underline transition-colors self-start"
          [ngClass]="{
            'text-gray-600 hover:text-gray-800': mode() === 'info',
            'text-orange-700 hover:text-orange-900': mode() === 'warning',
            'text-red-700 hover:text-red-900': mode() === 'error',
            'text-green-700 hover:text-green-900': mode() === 'success'
          }">
          {{ actionLabel() }}
        </button>
      }
    </div>
  </div>
</div>
